"use client";

import React, { ReactNode, useState } from "react";
import { TaskContext, TaskContextType } from "../context/TaskContext";

interface TaskProviderProps {
    children: ReactNode;
}

export const TaskProvider = ({ children }: TaskProviderProps) => {
    const [tasks, setTasks] = useState<TaskContextType["tasks"]>(null);

    const contextValue: TaskContextType = {
        tasks,
        setTasks,
    };

    return <TaskContext.Provider value={contextValue}>{children}</TaskContext.Provider>;
};
